import { render, staticRenderFns } from "./leader-details.vue?vue&type=template&id=30f5a681"
import script from "./leader-details.vue?vue&type=script&lang=js"
export * from "./leader-details.vue?vue&type=script&lang=js"
import style0 from "./leader-details.vue?vue&type=style&index=0&id=30f5a681&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports